// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlight {
    background-color: #ffff99; /* Highlight color for today's date */
}

.spuelplan-button {
    background-color: var(--mittelblau);
}`, "",{"version":3,"sources":["webpack://./src/components/dienstplaene/Dienstplaene.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,qCAAqC;AACpE;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".highlight {\n    background-color: #ffff99; /* Highlight color for today's date */\n}\n\n.spuelplan-button {\n    background-color: var(--mittelblau);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
